import React from 'react';

export function AppShell({ children, isRouting }) {
  // If we are dynamically routing to TEF Designer (loading state)
  if (isRouting) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#08081a' }}>
        <div style={{ width: 40, height: 40, border: '3px solid rgba(6,182,212,0.2)', borderTopColor: '#06b6d4', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      </div>
    );
  }

  return (
    <div className="app-shell text-sky-50" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'linear-gradient(135deg, #020617 0%, #0a1929 40%, #0c1e3a 100%)', overflowX: 'hidden' }}>
      {children}
    </div>
  );
}

export function MainContent({ children, showHeaderSpacer }) {
  return (
    <main className="flex-1 w-full" style={{ position: 'relative', zIndex: 1 }}>
      {showHeaderSpacer && (
        <div className="header-spacer" style={{ height: 'calc(var(--header-height, 155px) + var(--header-gap, 36px))', flexShrink: 0 }}></div>
      )}
      {children}
    </main>
  );
}
